export type ExchangeType = 'ICE' | 'Other-Exhanges';
export type PlatformType = 'WebICE' | 'TT';

export interface FixActionStatus {
  status: string;
  connected: boolean;
  message: string;
  logout_reason: string | null;
}

export interface FixActionResponse {
  status: string;
  message: string;
  data: {
    api_status: boolean;
    message: string;
    status: FixActionStatus;
  };
}

export interface FixFieldDetail {
  time: string;
  message: string;
}

export interface TradeCaptureDetail {
  status: string;
  message: string;
}

export interface FixSessionData {
  login_time: FixFieldDetail;
  last_active: FixFieldDetail;
  last_logout: FixFieldDetail;
  logout_reason: FixFieldDetail;
  last_trade_capture_request: FixFieldDetail;
  last_trade_capture_response: FixFieldDetail;
  trade_capture_status: TradeCaptureDetail;
}

export interface FixSessionResponse {
  api_status: boolean;
  fix_session: FixSessionData;
}

export interface FixStatusResponse {
  status: string;
  running: {
    api_status: boolean;
    connection: {
      status: string;
      connected: boolean;
      message: string;
      logout_reason: string | null;
    };
  };
}

export const PLATFORMS_BY_EXCHANGE: Record<ExchangeType, PlatformType[]> = {
  ICE: ['WebICE', 'TT'],
  'Other-Exhanges': ['WebICE', 'TT'],
};

export const EXCHANGES: ExchangeType[] = ['ICE', 'Other-Exhanges'];

export const SESSION_ROW_META: {
  key: keyof Omit<FixSessionData, 'trade_capture_status'>;
  label: string;
  dot: string;
}[] = [
  { key: 'login_time', label: 'Login Time', dot: '#2f9bd6' },
  { key: 'last_active', label: 'Last Active', dot: '#f2a93b' },
  { key: 'last_logout', label: 'Last Logout', dot: '#8bc34a' },
  { key: 'logout_reason', label: 'Logout Reason', dot: '#ec4899' },
  { key: 'last_trade_capture_request', label: 'Last Trade Capture Request', dot: '#2f9bd6' },
  { key: 'last_trade_capture_response', label: 'Last Trade Capture Response', dot: '#f2a93b' },
];

export const TRADE_CAPTURE_KEY = 'trade_capture_status';
export const ALL_ROW_KEYS = [...SESSION_ROW_META.map((m) => m.key as string), TRADE_CAPTURE_KEY];